<template>
  <div v-if="card && card.info && (card.info.total_evaluations_visibility || card.user_id !== user.id)">
    {{scope.row.scale.fact}}
  </div>
  <div
    v-else
    style="color: #b1b1b2;"
  >
    Скрыто
  </div>
</template>

<script>

import {ElementPropTableColumn} from "@/mixins/elementPropTableColumn";
import {mapGetters} from "vuex";

export default {
  name: 'element-fact-chief-section-table-column',
  mixins: [ElementPropTableColumn],

  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['user']),
    ...mapGetters('card', {
      card: 'card',
    }),
  },
  methods: {}
}

</script>

<style scoped lang="scss">
@import "@/assets/css/project-variables";
</style>
